<template>
    <v-form
        ref="form"
        :model="input"
        :action="endpoint"
        :method="method"
        @submitted="handleSubmitted"
    >
        <template scope="{ error, errorState }">
            <b-tabs>
                <b-tab title="Series"
                       active>
                    <v-input-field
                        label="Title"
                        description="The title for the series."
                        v-model="input.title"
                        :error="error('title')"
                        placeholder="Enter Title"
                        :state="errorState('title')"
                    />

                    <v-input-field
                        label="Subtitle"
                        description="The subtitle for the series."
                        v-model="input.subtitle"
                        :error="error('title')"
                        placeholder="Enter Subtitle"
                        :state="errorState('subtitle')"
                    />

                    <v-rich-text-field
                        label="Description"
                        description="The Series Description"
                        v-model="input.description"
                        placeholder="Enter Description."
                        :state="errorState('description')"
                        :error="error('description')"
                    />

                    <messages-field
                        v-model="input.messages"
                        label="Messages"
                        :error="error('messages')"
                        :state="errorState('messages')"/>

                    <v-tags-field
                        label="Tags"
                        description="Search tags for the series."
                        v-model="input.tags"
                        :state="errorState('tags')"
                        :error="error('tags')"
                    />
                </b-tab>

                <b-tab title="Promo">
                    <v-video-field
                        v-model="input.promo_video_url"
                        placeholder="Enter URL"
                        :state="errorState('promo_video_url')"
                        label="Promo Video"
                        description="The URL to the Vimeo video."
                        :error="error('promo_video_url')"/>

                    <v-rich-text-field
                        label="Promo Copy"
                        description="Promotional copy for the series."
                        v-model="input.promo_copy"
                        placeholder="Enter Promo Copy"
                        :state="errorState('promo_copy')"
                        :error="error('promo_copy')"
                    />
                </b-tab>

                <b-tab title="Images">

                    <v-image-file-field
                        name="banner-image-file"
                        label="Banner Image"
                        description="1920px x 692px"
                        :state="errorState('banner_image_id')"
                        :error="error('banner_image_id')"
                        v-model="input.banner_image_id"/>

                    <v-image-file-field
                        name="square-image-file"
                        label="Square Image"
                        description="1024px x 1024px"
                        :state="errorState('square_image_id')"
                        :error="error('square_image_id')"
                        v-model="input.square_image_id"/>

                    <v-image-file-field
                        name="wide-image-file"
                        label="Wide Image"
                        description="1920px x 1080px"
                        :state="errorState('wide_image_id')"
                        :error="error('wide_image_id')"
                        v-model="input.wide_image_id"/>

                </b-tab>
            </b-tabs>
        </template>
    </v-form>
</template>

<script>
    import axios from "axios"
    import MessagesField from "../Fields/MessagesField"

    export default {
        components: {MessagesField},
        props: ["series"],
        data()
        {
            return {
                input: {
                    title: null,
                    subtitle: null,
                    description: null,
                    messages: [],
                    banner_image_id: null,
                    square_image_id: null,
                    wide_image_id: null,
                    promo_video_url: null,
                    promo_video_copy: null,
                    tags: []
                },
                error: ""
            }
        },
        computed: {
            exists()
            {
                return this.series ? true : false
            },
            endpoint()
            {
                if (this.exists) {
                    return "/series/" + this.series.id
                } else {
                    return "/series"
                }
            },
            method()
            {
                if (this.exists) {
                    return "PUT"
                } else {
                    return "POST"
                }
            }
        },
        created()
        {
            if (this.exists) {
                this.input = this.series
            }
        },
        methods: {
            handleSubmitted()
            {
                if (!this.exists) {
                    location.href = "/series"
                }
            }
        }
    }
</script>